<template>
  <div ref="pdfContent" style="font-family: 'sansation' !important ">
    <div v-if="!loading" v-for="item in students" class="a4-page" :style="{pageBreakAfter: index < students.length - 1 ? 'always' : 'avoid'}">
      <div class="page cover">
        <div style="padding: 400px 30px; ">
          <table style="color: black; font-size: 20px; background-color: white; font-weight: bold; opacity: 0.8; width: 100%; border-collapse: collapse; padding: 10px;" border="1">
            <tr>
              <td style="width: 20%" class="cell-upper-padding">GRADE</td>
              <td colspan="3" class="cell-upper-padding uc">{{ item.Class }}</td>
            </tr>
            <tr>
              <td class="cell-upper-padding">STUDENT ID</td>
              <td class="cell-upper-padding uc" colspan="3">{{ item.AdmissionNo }}</td>
            </tr>
            <tr>
              <td class="cell-upper-padding">NAME</td>
              <td class="cell-upper-padding uc" colspan="3">{{ item.Name }}</td>
            </tr>
            <tr>
              <td class="cell-upper-padding uc" style="width: 20%">SESSION</td>
              <td class="cell-upper-padding uc" style="width: 30%">{{ session }}</td>
              <td class="cell-upper-padding uc" style="width: 20%">TERM</td>
              <td class="cell-upper-padding uc" style="width: 30%">{{ term }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div>
        <p class="heading-lg" style="color: #f15a22; margin-top: 10px; margin-bottom: 5px;">Core Skills are to be scored using the following key:</p>
        <table>
          <tbody>
            <tr>
              <td class="spacing-sm heading-lg bg-orange text-center" width="6%">{{generalProgressGrades[0].Score}}</td>
              <td class="spacing-sm value-lg bg-pink" width="27%">{{generalProgressGrades[0].Option}}</td>
              <td class="spacing-sm heading-lg bg-blue text-center" width="6%">{{generalProgressGrades[1].Score}}</td>
              <td class="spacing-sm value-lg bg-pink" width="27%">{{generalProgressGrades[1].Option}}</td>
              <td class="spacing-sm heading-lg bg-orange text-center" width="6%">{{generalProgressGrades[2].Score}}</td>
              <td class="spacing-sm value-lg bg-pink" width="27%">{{generalProgressGrades[2].Option}}</td>
            </tr>
            <tr>
              <td v-if="generalProgressGrades[3]" class="spacing-sm heading-lg bg-blue text-center">{{generalProgressGrades[3].Score}}</td>
              <td v-if="generalProgressGrades[3]" class="spacing-sm value-lg bg-pink">{{generalProgressGrades[3].Option}}</td>
              <td v-if="generalProgressGrades[4]" class="spacing-sm heading-lg bg-orange text-center">{{generalProgressGrades[4].Score}}</td>
              <td v-if="generalProgressGrades[4]" class="spacing-sm value-lg bg-pink">{{generalProgressGrades[4].Option}}</td>
              <td v-if="generalProgressGrades[5]" class="spacing-sm heading-lg bg-blue text-center">{{generalProgressGrades[5].Score}}</td>
              <td v-if="generalProgressGrades[5]" class="spacing-sm value-lg bg-pink">{{generalProgressGrades[5].Option}}</td>
            </tr>
          </tbody>
        </table>

        <p class="value-lg" style="border-top: 2px solid #f15a22; border-bottom: 2px solid #f15a22 ">
          <span class="heading-lg text-bold" style="color: #f15a22;">Note: </span>All assesment/exam scores, highest scores and averages are reported in percentages.
        </p>

        <div v-for="s in item.Subjects" style="margin-top: 5px">
          <table style="margin: 0px">
            <tr class="heading-lg">
              <td class="bg-blue uc b" width="60%">{{s.CourseName}}</td>
              <td v-if="s.AssessmentEvaluation" class="bg-orange uc text-center">ASSESSMENT RESULTS (%)</td>
              <td v-else class="bg-orange uc text-center">RESULTS</td>
            </tr>
          </table>
          <table style="margin: 0px;" v-if="s.AssessmentEvaluation ">
            <tbody class="value-md">
              <tr class="bg-pink" style="border-bottom: 1px solid black">
                <td class="heading-md text-center" style="border-right: 1px solid black">Assessment 1</td>
                <td class="heading-md text-center" style="border-right: 1px solid black">Assessment 2</td>
                <td class="heading-md text-center" style="border-right: 1px solid black">Term Exam</td>
                <td class="heading-md text-center" style="border-right: 1px solid black">Weighted Average</td>
                <td class="heading-md text-center ">Highest Class Score</td>
              </tr>
              <tr class=text-center>
                <td class="value-md text-center" style="border-right: 1px solid black">{{s.Assessment1Percentage.toFixed(2)}}</td>
                <td class="value-md text-center" style="border-right: 1px solid black">{{s.Assessment2Percentage.toFixed(2)}}</td>
                <td class="value-md text-center" style="border-right: 1px solid black">{{s.ExamPercentage.toFixed(2)}}</td>
                <td class="value-md text-center" style="border-right: 1px solid black">{{s.WeightedAverage.toFixed(2)}}</td>
                <td class="value-md text-center">{{s.Highest.toFixed(2)}}</td>
              </tr>
            </tbody>
          </table>
          <table border="1" style="margin: 0px; border-color: white" v-for="k in s.Key">
            <thead v-if="!k.IsSpecificRemarks">
              <tr class="heading-lg bg-orange">
                <th></th>
                <th class="uc">{{k.Category}}</th>
              </tr>
            </thead>
            <thead v-else>
              <tr class="heading-lg bg-orange">
                <th class="uc">SPECIFIC REMARKS</th>
              </tr>
            </thead>
            <tbody v-if="!k.IsSpecificRemarks">
              <tr class="value-md" v-for="c in k.Child">
                <td class="bg-gray b" align="center">{{c.Score}}</td>
                <td class="bg-pink" width="90%">{{c.Question}} </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr class="value-md" v-for="c in k.Child">
                <td class="bg-pink">{{c.Question}} <b>{{c.Option}}</b></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <br />

      <table border="1" style=" margin-bottom: 5px; border-color: white; font-weight: bold" v-for="gp in generalProgress.filter((x) => {return  x.GeneralProgressID == 3 && x.StudentID == item.StudentID})">
        <tr class="heading-lg">
          <td class="bg-orange b" align="center">{{gp.Name}}</td>
        </tr>
        <tr class="value-md">
          <td class="bg-pink" width="50%">{{gp.Value}}</td>
        </tr>
      </table>

      <table border="1" style=" margin-bottom: 5px; border-color: white; font-weight: bold" v-for="gp in generalProgress.filter((x) => {return  x.GeneralProgressID != 3 && x.StudentID == item.StudentID})">
        <tr class="">
          <td class="bg-orange b heading-lg" width="50%" align="center">{{gp.Name}}</td>
          <td class="bg-pink value-md" width="50%">{{gp.Value}}</td>
        </tr>
      </table>

      <!--<table border="1" style="border-color: white; font-weight: bold" v-for="gp in generalProgress.filter((x) => {return  x.GeneralProgressID == 2 && x.StudentID == item.StudentID})">
        <tr class="value-md">
          <td class="bg-orange b" width="50%" align="center">{{gp.Name}}</td>
          <td class="bg-pink" width="50%">{{gp.Value}}</td>
        </tr>
      </table>

      <table border="1" style=" border-color: white; font-weight: bold" v-for="gp in generalProgress.filter((x) => {return  x.GeneralProgressID == 4 && x.StudentID == item.StudentID})">
        <tr class="value-md">
          <td class="bg-orange b" width="50%" align="center">{{gp.Name}}</td>
          <td class="bg-pink" width="50%">{{gp.Value}}</td>
        </tr>
      </table>

      <table border="1" style=" border-color: white; font-weight: bold" v-for="gp in generalProgress.filter((x) => {return  x.GeneralProgressID == 5 && x.StudentID == item.StudentID})">
        <tr class="value-md">
          <td class="bg-orange b" width="50%" align="center">{{gp.Name}}</td>
          <td class="bg-pink" width="50%">{{gp.Value}}</td>
        </tr>
      </table>

      <table border="1" style=" border-color: white; font-weight: bold" v-for="gp in generalProgress.filter((x) => {return  x.GeneralProgressID == 6 && x.StudentID == item.StudentID})">
        <tr class="value-md">
          <td class="bg-orange b" width="50%" align="center">{{gp.Name}}</td>
          <td class="bg-pink" width="50%">{{gp.Value}}</td>
        </tr>
      </table>

      <table border="1" style=" border-color: white; font-weight: bold" v-for="gp in generalProgress.filter((x) => {return  x.GeneralProgressID == 7 && x.StudentID == item.StudentID})">
        <tr class="value-md">
          <td class="bg-orange b" width="50%" align="center">{{gp.Name}}</td>
          <td class="bg-pink" width="50%">{{gp.Value}}</td>
        </tr>
      </table>

      <table border="1" style=" border-color: white; font-weight: bold" v-for="gp in generalProgress.filter((x) => {return  x.GeneralProgressID == 8 && x.StudentID == item.StudentID})">
        <tr class="value-md">
          <td class="bg-orange b" width="50%" align="center">{{gp.Name}}</td>
          <td class="bg-pink" width="50%">{{gp.Value}}</td>
        </tr>
      </table>-->

    </div>
    <div v-if="loading" class="loading-overlay">
      <div class="loading-card">

        <div class="book">
          📚
        </div>

        <h2>Preparing Your Result Card</h2>

        <p class="loading-text">
          {{ loadingMessage }}
        </p>

        <div class="progress">
          <div class="progress-fill"></div>
        </div>

        <div class="loading-footer">
          Please don't close this page.<br>
          This usually takes a few seconds.
        </div>

      </div>
    </div>
  </div>
</template>
<script>
  import html2pdf from "html2pdf.js";
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        students: [],
        generalProgress: [],
        generalProgressGrades: [],
        assessmentType: "",
        term: "",
        header: { Logo: '', Name: '', Campus: '' },
        loading: true,
        loadingMessage: "📚 Collecting your academic records...",
        loadingInterval: null,
        session: '',
        displayMarks: false
      }
    },
    created: function () {
      this.getPrint();
    },
    methods: {
      getPrint() {
        this.loading = true;
        const messages = [
          "📚 Collecting your academic records...",
          "📝 Calculating assessment scores...",
          "📊 Preparing performance summary...",
          "🏅 Adding teacher remarks...",
          "🎓 Generating official result card...",
          "✨ Almost done..."
        ];

        let i = 0;

        this.loadingInterval = setInterval(() => {

          if (i < messages.length - 1) {
            i++;
            this.loadingMessage = messages[i];
          } else {
            clearInterval(this.loadingInterval);
          }

        }, 1800);
        const params = new URLSearchParams(window.location.search);
        const UID = params.get('UID') || '';
        var vm = this;
        startReq();
        axios.post('/api/PortalApi/loadSSSResultCard?UID=' + UID)
          .then(function (response) {
            vm.students = response.data.studentsFinal;
            vm.generalProgress = response.data.generalProgress;
            vm.header = response.data.header;
            vm.assessmentType = response.data.assessmentType;
            vm.term = response.data.term;
            vm.session = response.data.session;
            vm.generalProgressGrades = response.data.generalProgressGrades;
            vm.displayMarks = response.data.displayMarks;
            endReq();
            vm.loading = false;
            clearInterval(vm.loadingInterval);

            vm.$nextTick(function () {
              setTimeout(function () {
                window.print();
                //vm.downloadPDF();
              }, 500);
            });
          })
          .catch(function (error) {
            console.log(error.response);
            alert("An internal error occurred");
          });
      },
      downloadPDF() {
        const element = this.$refs.pdfContent;

        html2pdf()
          .from(element)
          .set({
            margin: 0,
            filename: 'ResultCard.pdf',
            image: { type: 'jpeg', quality: 1 },
            html2canvas: { scale: 2, useCORS: true },
            jsPDF: {
              unit: 'mm',
              format: 'a4',
              orientation: 'portrait'
            }
          })
          .save();
      },

      getGeneralComments(studentID) {
        var data = this.generalProgress.find(u => u.StudentID == studentID);
        if (data) {
          return data.Value;
        }
        else {
          return 0;
        }
      },
    }
  })</script>
<style scoped>


  table {
    width: 100%;
    border-color: black;
    border-collapse: collapse;
    margin-bottom: 10px
  }

  .heading-lg {
    font-size: 16px;
    line-height: 24px;
    font-weight: bold;
    text-align: left;
  }

  .heading-md {
    font-size: 12px;
    line-height: 20px;
    font-weight: bold;
    text-align: left;
  }
  .cell-upper-padding {
    padding: 5px;
    text-transform: uppercase;
    white-space: nowrap;
  }
  .value-lg {
    font-size: 14px;
    line-height: 20px;
    text-align: left;
  }

  .value-md {
    font-size: 12px;
    line-height: 20px;
    text-align: left;
  }

  .num {
    text-align: center;
  }

  .text-center {
    text-align: center;
  }

  .container {
    display: grid;
    grid-template-columns: 33% 33% 34%;
  }

    .container > div {
      border: 0.3px solid black;
      padding-left: 2px;
      padding-right: 25px;
      text-align: left;
    }

  .bg-orange {
    background-color: #f15a22;
    color: white
  }

  .bg-blue {
    background-color: #012D5B;
    color: white
  }

  .bg-pink {
    background-color: #fdeee9;
    color: black
  }

  .bg-gray {
    background-color: #d9dee3;
    color: black
  }

  .b {
    font-weight: bold
  }

  .uc {
    text-transform: uppercase
  }

  .spacing-sm {
    padding: 5px
  }

  .cell-upper-padding {
    padding: 5px;
    text-transform: uppercase;
  }

  body {
    margin: 0px;
  }

  .page {
    width: 100%;
    min-height: 277mm;
  }
  .cover {
    background-image: url('/Images/ResultBackground.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }


  .a4-page {
    width: 210mm;
    min-height: 297mm;
    margin: 0 auto 10mm auto;
    padding: 10mm;
    box-sizing: border-box;
    background: #fff;
    overflow: hidden;
    page-break-after: always;
  }
  .loading-overlay {
    position: fixed;
    inset: 0;
    background: conic-gradient(from 45deg, #6f0000 0.000deg, #6f0000 17.143deg, #7b0000 calc(17.143deg + 0.1deg), #7b0000 34.286deg, #890000 calc(34.286deg + 0.1deg), #890000 51.429deg, #990000 calc(51.429deg + 0.1deg), #990000 68.571deg, #a80000 calc(68.571deg + 0.1deg), #a80000 85.714deg, #b80000 calc(85.714deg + 0.1deg), #b80000 102.857deg, #c51300 calc(102.857deg + 0.1deg), #c51300 120.000deg, #d12900 calc(120.000deg + 0.1deg), #d12900 137.143deg, #db4000 calc(137.143deg + 0.1deg), #db4000 154.286deg, #e15700 calc(154.286deg + 0.1deg), #e15700 171.429deg, #e46c00 calc(171.429deg + 0.1deg), #e46c00 188.571deg, #e37d00 calc(188.571deg + 0.1deg), #e37d00 205.714deg, #df8a00 calc(205.714deg + 0.1deg), #df8a00 222.857deg, #d79200 calc(222.857deg + 0.1deg), #d79200 240.000deg, #cd9300 calc(240.000deg + 0.1deg), #cd9300 257.143deg, #c08e00 calc(257.143deg + 0.1deg), #c08e00 274.286deg, #b18400 calc(274.286deg + 0.1deg), #b18400 291.429deg, #a27400 calc(291.429deg + 0.1deg), #a27400 308.571deg, #926100 calc(308.571deg + 0.1deg), #926100 325.714deg, #834a00 calc(325.714deg + 0.1deg), #834a00 342.857deg, #763300 calc(342.857deg + 0.1deg) 360.000deg);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;
  }

  .loading-card {
    width: 420px;
    background: white;
    border-radius: 20px;
    padding: 40px;
    text-align: center;
    box-shadow: 0 20px 50px rgba(0,0,0,.25);
  }

  .book {
    font-size: 60px;
    animation: bounce 1.5s infinite;
  }

  .loading-card h2 {
    color: #012D5B;
    margin-top: 15px;
  }

  .loading-text {
    margin: 20px 0;
    color: #666;
    min-height: 40px;
  }

  .progress {
    width: 100%;
    height: 10px;
    background: #eee;
    border-radius: 20px;
    overflow: hidden;
  }

  .progress-fill {
    width: 30%;
    height: 100%;
    background: linear-gradient(90deg,#f15a22,#ff944d);
    animation: loading 1.3s linear infinite;
  }

  .loading-footer {
    margin-top: 20px;
    color: #888;
    font-size: 14px;
  }

  @keyframes loading {
    from {
      transform: translateX(-100%);
    }

    to {
      transform: translateX(350%);
    }
  }

  @keyframes bounce {
    50% {
      transform: translateY(-8px);
    }
  }

  @page {
    size: A4 portrait;
    margin: 10mm;
  }

  @media print {

    html,
    body {
      width: 210mm;
      height: 297mm;
      margin: 0;
      padding: 0;
      background: white;
    }

    .a4-page {
      width: 100%;
      min-height: auto;
      margin: 0;
      padding: 0;
      page-break-after: always;
      break-after: page;
      box-shadow: none;
    }

    .loading-overlay {
      display: none !important;
    }

    table {
      page-break-inside: avoid;
    }

    tr {
      page-break-inside: avoid;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/school/LMS/steppingStoneResultCardPrint.vue